import { render, staticRenderFns } from "./newsletter-list-toolbar.vue?vue&type=template&id=1a0aa5ae&"
import script from "./newsletter-list-toolbar.vue?vue&type=script&lang=js&"
export * from "./newsletter-list-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports